import Grid from '@mui/material/Grid'
import FilterFieldComponent from './FilterHomeFieldComponent'

const FilterField = ({ filter, filterForm }) => (
  <Grid container spacing={2}>
    <FilterFieldComponent filter={filter} filterForm={filterForm} />
  </Grid>
)

export default FilterField
